import classnames from 'classnames';
import { MyLink } from '@scramble/ui';
import { APP_LINKS } from '@/helpers/links';
import { EMPTY_DASH, prettyMoney } from '@scramble/utils';
import { useGetLenderDashboardStats } from '@/query/queries/dashboard/useGetLenderDashboardStats';
import IconWallet from '@scramble/design-system/icons/wallet-02.svg'
import IconCoins from '@scramble/design-system/icons/coins-stacked-01.svg'
import IconLayer from '@scramble/design-system/icons/layers-two-01.svg'
import s from './index.module.scss';

export const LenderStatistics = () => {
  const { data } = useGetLenderDashboardStats();
  return (
    <div className={s.cards}>
      <div className={s.card}>
        <div className={s.top}>
          <div className={s.icon}>
            <img src={IconWallet} alt="wallet" width={20} height={20} />
          </div>
          <MyLink href={APP_LINKS.withdraw} className={s.link}>
            Withdraw cash
          </MyLink>
        </div>
        <div className={s.bottom}>
          <div className={classnames(s.amount, 'f-hero-h5')}>
            {data ? prettyMoney(data.cash) : EMPTY_DASH}
          </div>
          <div className={classnames(s.label, 'f-small-accent')}>Cash</div>
        </div>
      </div>
      <div className={s.card}>
        <div className={s.top}>
          <div className={s.icon}>
            <img src={IconCoins} alt="wallet" width={20} height={20} />
          </div>
        </div>
        <div className={s.bottom}>
          <div className={classnames(s.amount, 'f-hero-h5')}>
            {data ? prettyMoney(data.claims_amount) : EMPTY_DASH}
          </div>
          <div className={classnames(s.label, 'f-small-accent')}>Claims amount</div>
        </div>
      </div>
      <div className={s.card}>
        <div className={s.top}>
          <div className={s.icon}>
            <img src={IconLayer} alt="wallet" width={20} height={20} />
          </div>
        </div>
        <div className={s.bottom}>
          <div className={classnames(s.amount, 'f-hero-h5')}>
            {data ? data.total_round : EMPTY_DASH}
          </div>
          <div className={classnames(s.label, 'f-small-accent')}>Total rounds</div>
        </div>
      </div>
    </div>
  );
};
